import { PropsWithChildren } from "react";
import { appInsights } from "./ApplicationInsightsService";

type CPLAnalyticsProps = {
  pageName?: string;
  children: React.ReactNode;
};

const CPLAnalytics: React.FC<PropsWithChildren<CPLAnalyticsProps>> = ({ pageName: componentName, children }) => {
  appInsights.trackPageView({ name: componentName });
  return <>{children}</>;
};

export { CPLAnalytics };
